var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternM",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.83,159.98v151.1h-1.45v-151.19c.48.03.96.06,1.45.09h0Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.26,245.27v-85.48h1.34v85.56c-.45-.03-.89-.05-1.34-.08Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M499.88,314.26v-51.47l1.09-.45c.5.85,1.42,1.7,1.43,2.56.09,15.76.08,31.53.01,47.29,0,.82-.72,1.64-1.1,2.47-.48-.13-.95-.26-1.43-.4Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.13,262.25c3.21,2.88,3.23,49.62,0,52.6v-52.6Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.18,262.44c3.08,2.41,3.27,49.1,0,52.62v-52.62Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M601.81,314.66c-.91-.3-1.73-.44-1.73-.59-.06-16.75-.05-33.5.45-50.57.65,1.86,1.84,3.72,1.85,5.59.14,14.62.06,29.25.01,43.88,0,.45-.3.9-.59,1.69h.01Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M478.87,181.71c1.4,14.81.14,29.7.67,44.54-.44.16-.88.32-1.32.49-.54-.7-1.55-1.41-1.55-2.11-.09-14.27-.07-28.54-.07-42.8.75-.03,1.51-.07,2.26-.1v-.02Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M286.97,181.7c1.13,14.83.21,29.71.56,45.79-1.64-1.38-2.79-1.9-2.79-2.42-.1-14.42-.08-28.84-.08-43.26l2.31-.11Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.99,380.64c-1.61-14.24-.66-43.04,1.4-44.92,2.24,5.46,1.43,42.22-1.4,44.92Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M476.91,335.18c3.7,3.05,3.4,42.6,0,45.29v-45.29Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M379.13,181.86v45.71c-1.34-1.51-2.43-2.16-2.44-2.83-.11-13.43-.12-26.87-.03-40.31,0-.99.94-1.96,1.45-2.95.34.12.68.24,1.02.36v.02Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M508.34,289.44c2.72,2.44,3.09,40.56,0,46v-46Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M578.24,380.06c-2.74-6.67-1.96-42.38,1.32-45.43-.35,15.91.49,30.73-1.32,45.43Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.81,334.09c-2.27-4.66-1.7-42.42.66-44.36,1.92,5.21,1.37,41.73-.66,44.36Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.21,334.05v-45.35c1.09,1.41,2.15,2.15,2.16,2.89.08,13.64.05,27.28-.02,40.91,0,.54-.64,1.07-.97,1.6-.39-.02-.77-.03-1.16-.05h0Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M407.81,180.17v-44.25c.33-.13.66-.26.99-.39.55,1.25,1.58,2.5,1.59,3.76.12,12.5.11,25,.02,37.49,0,1.24-.78,2.47-1.2,3.7-.47-.11-.94-.21-1.4-.32h0Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M310.15,416.18v44.28c-3.4-2.73-3.71-41.25,0-44.28Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M309.84,374.02v41.43c-2.74-3.12-3.13-37.09,0-41.43Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M500.25,414.76v-41.72c2.77,3.91,2.99,38.09,0,41.72Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M501.75,261.13c-3.1-4.1-2.73-38.22.71-41.43,0,14.49.04,27.96-.71,41.43Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M400.35,220.42c2.69,2.47,3.06,36.57,0,42.07v-42.07h0Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.35,220.41c2.7,2.5,3.06,36.61,0,42.08v-42.08h0Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340.74,252.89v53.46h-1.45v-53.4c.48-.02.96-.04,1.45-.06h0Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M341.25,313.69c.26,14.2.62,28.39-.33,42.59h-1.6v-42.59h1.93Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M448.02,275.95c-3.41-4.13-3.2-37.29,0-40.6v40.6Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M255.93,235.33v40.36c-3.25-3.67-3.15-36.89,0-40.36Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M548.08,275.34c-3.48-2.7-3.6-36.51,0-39.86v39.86Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M499.89,415.98c3.8,3.53,3.33,36.99,0,39.38v-39.38Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M256.18,429.07c-3.8-3.51-3.35-36.99,0-39.39v39.39h0Z",
    className: "patternColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M248.13,250.86v56.34c-.32,0-.64,0-.96.01v-56.35h.96Z",
    className: "patternColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M402.16,263.24v37.18c-1.72-.83-2.58-6.23-2.58-16.2,0-5.96-.07-11.93.05-17.89.03-1.31.71-2.6,1.09-3.9.48.27.96.54,1.43.81h.01Z",
    className: "patternColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M440.13,250.86v56.34c-.32,0-.64,0-.96.01v-56.35h.96Z",
    className: "patternColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M547.81,389.79c2.06,9.18.87,35.6-1.7,37.88-1.88-11.47-.76-36.42,1.7-37.88Z",
    className: "patternColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M538.95,307.21v-55.35c.3,0,.6,0,.9-.02v55.35h-.9v.02Z",
    className: "patternColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M318.48,142.93c-.04,12.73.06,25.07-.06,37.4-.89-.03-1.79-.05-2.68-.08,0-11.98-.02-23.95.1-35.92,0-.42,1.5-.82,2.63-1.4h0Z",
    className: "patternColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M530.86,353.63v-36.82l1.04-.44c.52.9,1.38,1.75,1.5,2.69,1.44,11.58.12,32.18-2.54,34.57Z",
    className: "patternColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M263.81,274.11v37.44c-2.67-3.06-3.13-32.82,0-37.44Z",
    className: "patternColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M454.22,311.06v-37.57c2.74,3.22,3.11,33.25,0,37.57Z",
    className: "patternColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M448.16,203.45c-2.78-2.23-3.63-14.39-2.52-33.23.07-1.26.9-2.48,2.52-3.38v36.62h0Z",
    className: "patternColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M547.96,357.05c-3.53-4.3-2.92-34.41,0-36.42v36.42h0Z",
    className: "patternColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M431.08,162.72c3.23,2.61,3.5,33.22,0,37.08v-37.08Z",
    className: "patternColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M238.88,316.66c3.69,2.68,3.7,34.08,0,36.76v-36.76Z",
    className: "patternColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M553.58,273.71c3.46,3.18,3.82,33.31.79,37.43-.96-12.09-.7-24.21-.79-37.43Z",
    className: "patternColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M355.9,310.96c-3.26-4.01-2.87-34.11,0-36.69v36.69Z",
    className: "patternColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M256.02,357.08c-3.62-4.17-3-34.02,0-36.36v36.36Z",
    className: "patternColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M402.09,126.22v35.28c-3.37-2.62-3.58-32.36,0-35.28Z",
    className: "patternColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M493.89,357.38c-2.98-3.53-3.31-29.17,0-34.16v34.16Z",
    className: "patternColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M301.98,324.24v32.89c-2.92-2.65-3.6-28.05,0-32.89h0Z",
    className: "patternColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M594.02,324.32v32.91c-3.03-2.93-3.61-28.04,0-32.91Z",
    className: "patternColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M494.04,203.86c-3.39-3.8-3.3-29.99,0-33.49v33.49Z",
    className: "patternColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M201.99,324.27v32.85c-2.97-2.65-3.64-27.69,0-32.85Z",
    className: "patternColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M302.14,203.49c-3.57-3.01-3.57-29.76,0-32.92v32.92Z",
    className: "patternColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M394.15,203.51c-3.61-3.63-3.6-30.01,0-32.89v32.89Z",
    className: "patternColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M456.18,431.79v32.63c-3.83-1.8-3.65-28.56,0-32.63Z",
    className: "patternColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M346.2,350.13v-36.11c2.17,12.09,3.7,24.19,0,36.11h0Z",
    className: "patternColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M561.9,264.16v-39.31c.43,0,.86,0,1.3,0v39.42c-.43-.03-.86-.07-1.3-.1Z",
    className: "patternColor"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M361.97,264.86v-40.1c2.56,3.06,2.8,35.28,0,40.1Z",
    className: "patternColor"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M270.05,418.23v-40.23c1.87,1.7,2.62,32.13,0,40.23Z",
    className: "patternColor"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M270.02,264.5v-39.66h1.22v39.66h-1.22Z",
    className: "patternColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M463.22,224.86v39.64c-.39,0-.78-.02-1.17-.02v-39.62c.39,0,.78,0,1.17,0h0Z",
    className: "patternColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M539.09,391.2v-40.12h.99v40.12h-.99Z",
    className: "patternColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M248.08,197.85v40.34c-.29,0-.57.02-.86.02v-40.35c.29,0,.57,0,.86,0h0Z",
    className: "patternColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M439,238.2v-40.35l.81-.03v40.36c-.27,0-.54,0-.81,0h0Z",
    className: "patternColor"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M539.03,237.57v-39.71c.34,0,.68,0,1.02,0v39.71c-.34,0-.68,0-1.02,0Z",
    className: "patternColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M248.05,350.86v40.35h-.95v-40.34h.95Z",
    className: "patternColor"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M325.2,427.94v36.04c-1.96-.95-2.49-8.78-1.81-17.59.48-6.18.09-12.42.09-18.64.57.06,1.15.12,1.72.19h0Z",
    className: "patternColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M355.33,157.25c-2.83-8.35-2.01-24.15.9-27.05.4,9.49.26,18.3-.9,27.05Z",
    className: "patternColor"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M561.96,411.87v-34.09c.45,0,.91,0,1.36.01v33.95c-.45.04-.91.09-1.36.13h0Z",
    className: "patternColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M325.03,274.37v36.31c-.39,0-.78.02-1.17.02v-36.35h1.17v.02Z",
    className: "patternColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M517.06,274.44v36.32h-1.24v-36.44c.41.04.82.08,1.24.12Z",
    className: "patternColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M223.72,311.26v-36.53c.42,0,.84,0,1.25-.01v36.41c-.42.04-.84.08-1.25.13Z",
    className: "patternColor"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M417.02,274.7v36.49c-.36,0-.73.01-1.09.02v-36.5c.36,0,.73,0,1.09-.01h0Z",
    className: "patternColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M454.07,181.66c3.26,2.79,3.46,22.47,0,26.1v-26.1Z",
    className: "patternColor"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M354.06,182.01c3.55,4.09,2.99,22.93,0,25.31v-25.31Z",
    className: "patternColor"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M232.83,358.37v26.56c-3.15-4.23-2.94-23.62,0-26.56Z",
    className: "patternColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M261.81,207.97v-26.01c3.48,1.73,3.97,21.95,0,26.01Z",
    className: "patternColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M332.84,230.47c-2.93-2.93-3.23-22.03,0-26.37v26.37Z",
    className: "patternColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M424.75,230.17c-2.72-2.27-3.28-21.05,0-26.5v26.5Z",
    className: "patternColor"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M525.47,230.59c-3.37-2.45-4.08-21.1-.74-25.68.83,8.39.7,16.82.74,25.68Z",
    className: "patternColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M524.86,358.43v26.33c-3.18-3.91-2.98-23.11,0-26.33Z",
    className: "patternColor"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M494.13,261.58c-3.63-4.3-3.53-23.24,0-25.85v25.85Z",
    className: "patternColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M394.04,234.59v27c-3.18-3.7-3.39-21.47,0-27Z",
    className: "patternColor"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M302.27,235.08v26.15c-3.5-2.91-3.9-22.04,0-26.15h0Z",
    className: "patternColor"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M261.74,399.57c-.24-8.82-.17-17.25.57-25.66,3.34,4.55,2.68,23.29-.57,25.66Z",
    className: "patternColor"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M554.26,399.37v-26.38c3.23,4.66,2.84,23.66,0,26.38Z",
    className: "patternColor"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M264.13,220.24v25.22c-3.42-1.79-3.66-22.34,0-25.22Z",
    className: "patternColor"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25,361.15v-25.87c.83.89,2.06,1.59,2.08,2.31.2,7.87.23,15.75.08,23.61-.72-.02-1.43-.03-2.15-.05h0Z",
    className: "patternColor"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M354.01,245.22c-1.38-10.02-.67-22.63,1.39-24.5,2.41,5.87,1.44,23.06-1.39,24.5Z",
    className: "patternColor"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M454.07,220.67c3.28,1.72,3.52,22.27,0,25.03v-25.03Z",
    className: "patternColor"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M553.92,246.11v-25.5c3.35,1.74,3.66,21.53,0,25.5Z",
    className: "patternColor"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M530.89,174.13c3.65,2.19,3.77,22.4,0,25.29v-25.29Z",
    className: "patternColor"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M554.21,361.03v-25.07c2.7,1.69,3.53,20.1,0,25.07Z",
    className: "patternColor"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M385.24,239.53c2.9,3.07,3.17,21.01,0,26.65v-26.65Z",
    className: "patternColor"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M585.18,265.86v-25.98c3,2.25,3.43,20.57,0,25.98Z",
    className: "patternColor"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M448.2,320.64v24.86c-3.64-2.93-3.83-22.05,0-24.86Z",
    className: "patternColor"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M484.9,418.37v-24.75c3.66,2.65,3.62,22.11,0,24.75Z",
    className: "patternColor"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M292.77,418.87v-25.05c3.58,1.85,3.96,21.18,0,25.05Z",
    className: "patternColor"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M494.26,389.11v25.18c-3.5-2.52-3.86-21.19,0-25.18Z",
    className: "patternColor"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M292.87,264.4v-24.45c3.63,2.07,3.84,21.6,0,24.45Z",
    className: "patternColor"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M302.02,414.76c-3.31-3.9-3.32-21.96,0-25.42v25.42Z",
    className: "patternColor"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M485.04,239.26c3.33,3.78,3.3,22.02,0,25.45v-25.45Z",
    className: "patternColor"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M233.25,206.2v23.89c-3.8-1.89-3.9-20.65,0-23.89Z",
    className: "patternColor"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M453.8,157.97v-23c3.49,1.7,3.96,18.9,0,23Z",
    className: "patternColor"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M507.91,158.24c3.57,3.1,3.67,19,0,22.23v-22.23Z",
    className: "patternColor"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M578.85,266.49v22.34c-3.19-4.03-2.97-20.08,0-22.34Z",
    className: "patternColor"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M477.35,266.31c2.61,2.64,2.97,17.39.91,21.69-1.95-2.37-2.53-14.4-.91-21.69Z",
    className: "patternColor"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M584.99,339.42c3.43,3.33,3.41,18.8,0,22.2v-22.2Z",
    className: "patternColor"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M377.25,288.1v-21.27c2.62,1.22,3.41,15.92,0,21.27Z",
    className: "patternColor"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M285.25,288.11v-21.29c2.65,1.26,3.42,16,0,21.29Z",
    className: "patternColor"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M507.76,284.83v-22c3.6,2.04,3.95,18.25,0,22Z",
    className: "patternColor"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M384.92,208.64v-23.01c3.19,2.53,3.54,17.13,0,23.01Z",
    className: "patternColor"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M209.86,239.22v22.55c-3.52-4.32-2.9-19.03,0-22.55h0Z",
    className: "patternColor"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M407.93,262.18c3.57,3.78,3.39,19.46,0,22.32v-22.32Z",
    className: "patternColor"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M279.17,189.47v21.97c-3.55-3.04-3.63-18.74,0-21.97Z",
    className: "patternColor"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M502.01,166.14v22.01c-3.24-2.56-3.35-18.89,0-22.01Z",
    className: "patternColor"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M401.79,189.19c-3.12-4.77-2.86-20.31,0-22.74v22.74Z",
    className: "patternColor"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M371.18,211.38c-3.67-2.66-3.69-18.99,0-21.73v21.73Z",
    className: "patternColor"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M309.77,166.47v22.76c-3.1-4.86-2.82-20.4,0-22.76Z",
    className: "patternColor"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M471.21,189.7v21.46c-3.7-2.29-3.84-18.79,0-21.46h0Z",
    className: "patternColor"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M238.89,258.64c3.69,2.78,3.65,19.11,0,21.71v-21.71Z",
    className: "patternColor"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M430.9,280.31v-21.71c3.68,2.9,3.6,19.24,0,21.71Z",
    className: "patternColor"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M530.95,258.57c3.52,3,3.53,18.88,0,21.91v-21.91Z",
    className: "patternColor"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M215.9,284.43v-21.72c3.62,2.53,3.69,18.87,0,21.72Z",
    className: "patternColor"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M315.98,262.39c3.45,3.38,3.42,19.01,0,22.2v-22.2Z",
    className: "patternColor"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M287.14,420.62v20.61c-.4.14-.8.27-1.2.41-.45-1.12-1.24-2.22-1.31-3.36-.73-12.66-.24-16.28,2.5-17.66h.01Z",
    className: "patternColor"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M279.17,343.62v20.63c-.49.12-.97.23-1.46.35-.37-1.53-1.04-3.05-1.08-4.59-.34-14.65-.31-14.65,2.54-16.39h0Z",
    className: "patternColor"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M599.91,341.92v-21.32c3.4,1.68,3.7,18.21,0,21.32Z",
    className: "patternColor"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M470.97,364.98c-3.26-3.62-3.2-18.56,0-21.75v21.75Z",
    className: "patternColor"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M209.73,341.24c-2.68-1.37-3.28-16.63,0-21.8v21.8Z",
    className: "patternColor"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M531.21,434.02v-21.04c2.72,1.78,3.51,16.19,0,21.04Z",
    className: "patternColor"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M501.9,320.45c1.63,9.78.83,19.52-1.6,20.83-1.7-6.94-.99-18.86,1.6-20.83Z",
    className: "patternColor"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M470.77,143.55v22.77c-3.1-5.16-2.79-19.76,0-22.77Z",
    className: "patternColor"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M292.79,362.07v-22.29c3.52,2.17,3.86,17.39,0,22.29Z",
    className: "patternColor"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M484.92,361.52v-21.88c3.55,2.79,3.59,18.12,0,21.88Z",
    className: "patternColor"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M470.78,318.44c-2.81-2.38-3.19-17.27,0-21.89v21.89h0Z",
    className: "patternColor"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M278.7,318.23c-2.63-1.84-3.22-16.4,0-22v22Z",
    className: "patternColor"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M478.93,441.78c-3.18-2.78-3.21-18.6,0-21.57v21.57Z",
    className: "patternColor"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M309.9,320.45c1.63,9.78.83,19.52-1.6,20.83-1.7-6.94-.99-18.86,1.6-20.83Z",
    className: "patternColor"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M370.9,143.79v21.99c-3.38-4.72-3.04-19.51,0-21.99Z",
    className: "patternColor"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M484.84,315.31v-21.33c3.44,1.71,3.89,16.77,0,21.33Z",
    className: "patternColor"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92,315.7v-21.95c3.26,2.28,3.69,16.77,0,21.95Z",
    className: "patternColor"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M370.59,297.46c1.26,6.86.74,13.8.87,21.14-3.33-2.41-4.02-16.64-.87-21.14Z",
    className: "patternColor"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M317.83,437.69c-2.53-2.2-3.09-9.76-1.91-20.73,2.79,1.49,3.72,11.06,1.91,20.73Z",
    className: "patternColor"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M385.12,138.83c3.14,5.1,3.11,18.49,0,23.27v-23.27Z",
    className: "patternColor"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M570.45,318.21c-2.76-6.77-1.46-13.73-.84-20.67,2.88,6.74,1.38,13.73.84,20.67Z",
    className: "patternColor"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M507.88,438.05v-21.38c3.34,2.44,3.73,17.99,0,21.38Z",
    className: "patternColor"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M571.09,343.51c1.23,11.78.67,19.06-1.52,20.81-2.05-5.63-1.34-18.34,1.52-20.81Z",
    className: "patternColor"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M256.32,182.13v20.98c-3.86-1.89-3.96-17.68,0-20.98Z",
    className: "patternColor"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M301.98,445.19c-3.17-2.19-3.52-17.41,0-21.18v21.18Z",
    className: "patternColor"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M484.99,185.25c3.41,4.21,3.36,18.56,0,22.43v-22.43Z",
    className: "patternColor"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8,207.84v-22.08c3.58,2.77,3.84,17.76,0,22.08Z",
    className: "patternColor"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M494.16,423.59v21.65c-3.28-2.05-3.76-17.17,0-21.65Z",
    className: "patternColor"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M192.8,314.64v-20.89c3.62,2.3,3.83,17.59,0,20.89Z",
    className: "patternColor"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M584.9,314.45v-20.71c3.59,2.47,3.67,17.81,0,20.71Z",
    className: "patternColor"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M417.01,127.85v29.43h-1.09v-29.43h1.09Z",
    className: "patternColor"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M594.05,291.84c-3.36-4.52-3.34-18.03,0-21.44v21.44Z",
    className: "patternColor"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M494.14,269.43v21.82c-3.25-2.02-3.73-15.75,0-21.82Z",
    className: "patternColor"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M393.89,292.24c-3.41-5.68-3.03-19.02,0-21.37v21.37Z",
    className: "patternColor"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M302,291.35c-3.24-2.54-3.45-16.58,0-21.19v21.19Z",
    className: "patternColor"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M201.97,291.45c-3.19-3.76-3.38-17.28,0-21.24v21.24Z",
    className: "patternColor"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M454.46,335.83c3.15,6.31,1.32,13.04,1.41,19.63-4.19-6.16-1.09-13.07-1.41-19.63Z",
    className: "patternColor"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M608.09,321.02v-31.27c.3.01.6.02.9.03v31.38c-.3-.05-.6-.09-.9-.14Z",
    className: "patternColor"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M539.75,404.85v28h-.91v-28h.91Z",
    className: "patternColor"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M316.91,443.81c2.31,6,1.24,12.26,1.57,18.8-3.19-1.6-3.86-8.41-1.57-18.8Z",
    className: "patternColor"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M347.98,132.77v25.78c-1.18-2-2.27-3-2.3-4.03-.16-6.34-.15-12.7-.03-19.04.02-1.03.84-2.05,1.3-3.08.34.12.69.25,1.03.37Z",
    className: "patternColor"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M422.61,199.19c.31-5.81-.87-11.73,1.78-17.38,1.11,5.91,1.28,11.76.84,17.58-.87-.07-1.75-.13-2.62-.2Z",
    className: "patternColor"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M525.12,354.06c-3.53-3.63-3.29-15.66,0-18.53v18.53Z",
    className: "patternColor"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M531.95,227.88c2.53,5.65,1.12,11.56,1.54,17.79-3.22-1.72-3.95-10.86-1.54-17.79Z",
    className: "patternColor"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M231.28,335.78c2.46,1.32,3.17,8.68,1.67,17.44-2.64-1.57-3.44-9.95-1.67-17.44Z",
    className: "patternColor"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M333.13,335.66v17.83c-3.62-2.32-3.56-15.09,0-17.83Z",
    className: "patternColor"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M263.78,422.28c-2.48-1.31-3.13-7.77-1.75-17.4,2.73,1.73,3.55,9.9,1.75,17.4Z",
    className: "patternColor"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M448.15,212.08v18.38c-3.37-2.72-3.59-14.44,0-18.38Z",
    className: "patternColor"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M530.89,381.71c3.62,2.57,3.66,14.97,0,17.72v-17.72Z",
    className: "patternColor"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M548.18,212.68v17.73c-3.67-2.73-3.64-15.1,0-17.73Z",
    className: "patternColor"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M424.85,154.98v17.17c-2.74-.97-3.48-12.29,0-17.17Z",
    className: "patternColor"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M425.58,272.85c-3.52-2.27-4.03-13.54-1.28-18.59,2.31,6.36.6,12.23,1.28,18.59Z",
    className: "patternColor"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M525.17,326.42c-3.67-2.76-3.63-15.13,0-17.72v17.72Z",
    className: "patternColor"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M332.83,154.96v17.31c-2.7-1.35-3.36-12.29,0-17.31Z",
    className: "patternColor"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M256.15,212.6v17.7c-3.57-2.42-3.67-14.78,0-17.7Z",
    className: "patternColor"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M333.26,308.09v18c-3.49-1.7-3.92-13.96,0-18Z",
    className: "patternColor"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M233.27,308.14v18.07c-3.51-1.95-3.91-14.45,0-18.07Z",
    className: "patternColor"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M255.79,385.16c-3.08-4.66-2.86-16.26,0-18.75v18.75Z",
    className: "patternColor"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M525.15,426.99c-3.6-3.99-3.37-15.7,0-18.39v18.39h0Z",
    className: "patternColor"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M232.79,272.62c-2.87-2.54-3.1-14.07,0-18.7v18.7Z",
    className: "patternColor"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M371.01,234.41c-3.27-2.77-3.43-14.47,0-18.09v18.09Z",
    className: "patternColor"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M471.18,234.37c-3.64-2.6-3.67-14.97,0-17.72v17.72Z",
    className: "patternColor"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M555.74,268.25c-2.72-1.39-3.26-13.08,0-18.6v18.6Z",
    className: "patternColor"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M455.7,268.75c-2.62-2.66-2.94-13.46-.9-17.68,1.98,2.4,2.46,10.69.9,17.68Z",
    className: "patternColor"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M571.16,216.63v17.72c-3.6-2.52-3.67-14.89,0-17.72Z",
    className: "patternColor"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M355.72,249.6v18.61c-2.66-1.25-3.26-12.88,0-18.61h0Z",
    className: "patternColor"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M262.32,249.65c3.26,5.52,2.72,17.22,0,18.6v-18.6Z",
    className: "patternColor"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M571.26,243.38v17.91c-3.62-2.23-3.84-14.52,0-17.91Z",
    className: "patternColor"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M471.27,243.11v18c-3.51-1.74-3.92-14,0-18h0Z",
    className: "patternColor"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M371.26,243.07v18.01c-3.48-1.67-3.92-13.93,0-18.01Z",
    className: "patternColor"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M279.15,243.6v17.69c-3.57-2.41-3.67-14.78,0-17.69Z",
    className: "patternColor"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M238.98,381.39c3.43,3.33,3.4,15.04,0,18.21v-18.21Z",
    className: "patternColor"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M525.13,199.61c-3.54-3.2-3.48-15.15,0-17.96v17.96h0Z",
    className: "patternColor"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M333.2,181.23v18.15c-3.46-2.42-3.71-14.38,0-18.15Z",
    className: "patternColor"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M279.04,234.52c-3.34-3.04-3.41-14.73,0-18.13v18.13Z",
    className: "patternColor"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M370.95,287.91c-3.31-4.2-2.95-14.66,0-17.43v17.43Z",
    className: "patternColor"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M431.2,228c3.18,4.29,2.78,14.7,0,17.62v-17.62Z",
    className: "patternColor"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M239.25,245v-17.99c3.49,4.94,2.86,16.41,0,17.99Z",
    className: "patternColor"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M571.14,370.56v16.74c-3.58-1.8-3.73-14.2,0-16.74Z",
    className: "patternColor"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M333.52,272.58c-3.43-2.25-4.08-12.99-1.23-18.37,2.21,6.37.7,12.22,1.23,18.37Z",
    className: "patternColor"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M525.62,272.69c-3.54-2.41-4.16-13.22-1.33-18.44,2.34,6.32.53,12.19,1.33,18.44Z",
    className: "patternColor"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M570.82,270.9v18.21c-3.33-5.22-2.86-16.3,0-18.21Z",
    className: "patternColor"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M548,366.47v17.7c-3.35-2.67-3.27-14.58,0-17.7Z",
    className: "patternColor"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M279.13,396.82v17.67c-3.29-1.93-3.62-13.89,0-17.67Z",
    className: "patternColor"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M301.87,293.81v18.07c-3.31-4.87-2.95-15.71,0-18.07Z",
    className: "patternColor"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M256.04,295.65c-2.9-2.85-3.4-13.05-1.27-17.57,1.95,2.26,2.41,8.14,1.27,17.57Z",
    className: "patternColor"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M469.31,441.25v-18.21c3.28,4.95,2.74,16.82,0,18.21Z",
    className: "patternColor"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M447.71,295.05c-2.63-1.94-3.23-12.71,0-18.48v18.48Z",
    className: "patternColor"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M493.92,293.64v18.01c-3.3-4.35-3.06-15.23,0-18.01Z",
    className: "patternColor"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M278.87,441.77c-3.03-2.75-3.11-13.72,0-18.65v18.65Z",
    className: "patternColor"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M547.95,278.15v16.78c-2.87-1.34-3.61-12.64,0-16.78Z",
    className: "patternColor"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M394.14,139.88v17.44c-3.31-2.51-3.64-11.85,0-17.44Z",
    className: "patternColor"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M278.99,387.56c-3.26-2.64-3.36-13.74,0-17.33v17.33Z",
    className: "patternColor"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M470.93,287.5c-3.47-4.4-2.85-14.64,0-16.64v16.64h0Z",
    className: "patternColor"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M278.77,287.64c-3.19-5.7-2.55-14.65,0-16.78v16.78Z",
    className: "patternColor"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M593.92,293.81v17.1c-.48,0-.96-.01-1.44-.02v-17.11c.48.01.96.02,1.44.03Z",
    className: "patternColor"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M363.42,131.87v21.42h-1.34v-21.41c.45,0,.89,0,1.34-.02h0Z",
    className: "patternColor"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M201.75,310.7c-3.15-5.39-2.28-11.14-1.32-16.89.44-.01.88-.03,1.32-.04v16.93Z",
    className: "patternColor"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M363.33,285.74v21.48c-.37.01-.74.02-1.11.03v-21.48l1.11-.03Z",
    className: "patternColor"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M409.63,305.58c-3.81-4.89-1-10.45-2.35-15.91,3.54,1.31,4.01,4.71,2.35,15.91Z",
    className: "patternColor"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M563.3,285.74v21.48c-.35.02-.69.03-1.04.05v-21.48c.35-.01.69-.03,1.04-.04h0Z",
    className: "patternColor"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M340.81,435.8v23.51h-1.45v-23.52h1.45Z",
    className: "patternColor"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M547.85,203.18c-3.83-4.85-1.44-10.45-1.75-15.75,4.32,4.7,1.2,10.5,1.75,15.75Z",
    className: "patternColor"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M323.79,211.2v-21.45c.4,0,.8,0,1.2,0v21.45h-1.2Z",
    className: "patternColor"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M440.09,130.85v22.35c-.29,0-.57.02-.86.04v-22.36c.29,0,.57-.02.86-.02h0Z",
    className: "patternColor"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M517.01,189.75v21.45h-1.2v-21.46h1.2Z",
    className: "patternColor"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M269.86,307.21v-21.23c2.17,1.47,2.66,15.69,0,21.23Z",
    className: "patternColor"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M484.96,145.77c3.45,2.42,3.58,11.53,0,15.85v-15.85Z",
    className: "patternColor"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M325.16,342.85v21.32c-.46.01-.92.03-1.38.04-.27-6.27-.58-12.54-.73-18.81-.01-.59.96-1.21,2.11-2.56h0Z",
    className: "patternColor"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M515.63,364.28v-20.4c.6-.02,1.2-.05,1.8-.07.07,6.79.12,13.57-.07,20.37-.58.04-1.15.07-1.73.11h0Z",
    className: "patternColor"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M463.32,285.74v21.45c-.36.02-.71.04-1.07.05v-21.29c.36-.07.71-.14,1.07-.22h0Z",
    className: "patternColor"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M515.73,448.1v-20.37c.36.02.72.03,1.08.05v20.26l-1.08.05h0Z",
    className: "patternColor"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M415.69,210.97v-21.14h1.22v21c-.41.04-.82.09-1.22.13h0Z",
    className: "patternColor"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M470.62,450.84c.28,4.86,2.23,9.89-1.2,14.4-.42-4.88-2.1-9.88,1.2-14.4Z",
    className: "patternColor"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M310.02,161.85c-3.32-3.73-3.25-12.12,0-15.51v15.51Z",
    className: "patternColor"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M554.16,404.99c3.34,4.33,2.8,12.13,0,14.65v-14.65Z",
    className: "patternColor"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M478.31,385.76c1.03,4.65,1.71,9.27-.42,13.6-1.27-4.66-1.9-9.25.42-13.6Z",
    className: "patternColor"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M285.02,399.31v-13.46c.29-.17.58-.33.87-.5.53.82,1.56,1.69,1.49,2.45-.35,3.87,1.31,8.11-.91,11.67-.48-.06-.97-.11-1.45-.17h0Z",
    className: "patternColor"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M223.83,364.21v-20.35c.33-.01.66-.03,1-.04v20.36c-.33,0-.66.01-1,.02h0Z",
    className: "patternColor"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M463.18,439.85v20.41c-.34.01-.69.02-1.03.03v-20.42c.34,0,.69,0,1.03-.01h0Z",
    className: "patternColor"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M424.92,303.25c-3.09-2.08-3.42-10.85,0-14.06v14.06Z",
    className: "patternColor"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M248.15,404.85v19.99c-2.17-6.57-1.33-13.29-1.52-19.95.51-.01,1.02-.03,1.52-.04h0Z",
    className: "patternColor"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M378.72,150.92v14.18c-.46,0-.92,0-1.37,0v-14.18c.46,0,.92,0,1.37,0Z",
    className: "patternColor"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M578.55,231.96v13.53c-.54-.07-1.09-.13-1.63-.2-.28-4.56-1.12-9.15,1.63-13.33Z",
    className: "patternColor"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M333.16,443.25v13.93c-3.42-2.23-3.64-11.16,0-13.93Z",
    className: "patternColor"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M333.16,289.71v13.73c-3.67-2.82-3.61-12.23,0-13.73Z",
    className: "patternColor"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M523.21,289.79c2.61,1.23,3.01,4.06,1.89,13.37-2.81-1.63-3.44-6.09-1.89-13.37Z",
    className: "patternColor"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M233.13,289.16v14.33c-3.37-2.53-3.59-11.34,0-14.33Z",
    className: "patternColor"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M425.63,136.07c-.21,4.48-.42,8.95-.63,13.43-.71-.08-1.42-.15-2.13-.23-.09-4.54-1.32-9.18.81-13.52.65.11,1.3.21,1.95.32h0Z",
    className: "patternColor"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M479.19,305.11v13.15c-.42.13-.85.26-1.27.38-.44-1.15-1.37-2.35-1.24-3.43.41-3.43-1.51-7.44,2.51-10.11h0Z",
    className: "patternColor"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M379.16,231.85v13.42c-.39.13-.77.26-1.16.39-.47-1-1.41-2.03-1.34-2.99.28-3.68-1.22-7.79,1.13-11.06.45.08.91.15,1.36.23h.01Z",
    className: "patternColor"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M284.44,319.2c.69-5.47-1.04-10.11,1.61-15.04,2.28,5.34,1.86,12.32-1.61,15.04Z",
    className: "patternColor"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M316.04,231.31c3.29,3.83,3.3,10.97,0,14.41v-14.41Z",
    className: "patternColor"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M285.35,230.58c2.94,5.17,2.71,12.56,0,15.09v-15.09Z",
    className: "patternColor"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M407.85,245.71v-14.03c3.55,2.95,3.7,10.58,0,14.03Z",
    className: "patternColor"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M215.79,245.97v-14.19c3.49,2.54,3.78,10.27,0,14.19Z",
    className: "patternColor"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M484.98,460.77v-13.84c3.73,3.86,3.41,12.18,0,13.84Z",
    className: "patternColor"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M577.17,305.06c3.15,3.84,2.87,11.21,0,13.68v-13.68Z",
    className: "patternColor"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M477.17,232.08c3.14,3.84,2.86,11.19,0,13.66v-13.66Z",
    className: "patternColor"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M478.8,165.94c-3.03-4.29-2.87-12.02,0-14.57v14.57Z",
    className: "patternColor"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M585.02,320.72c3.32,2.59,3.46,10.42,0,13.82v-13.82Z",
    className: "patternColor"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M507.94,231.64c3.48,3.12,3.53,10.84,0,13.87v-13.87Z",
    className: "patternColor"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M292.88,180.38v-13.73c3.61,2.68,3.6,11.12,0,13.73Z",
    className: "patternColor"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M384.82,181.12v-14.24c3.45,2.18,3.8,9.68,0,14.24Z",
    className: "patternColor"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M484.78,180.91v-14.01c3.52,1.82,3.86,10.16,0,14.01Z",
    className: "patternColor"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M517.17,385.91v17.23c-.4.01-.8.02-1.2.03v-17.35c.4.03.8.06,1.2.09Z",
    className: "patternColor"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M507.98,385.36c3.41,3.27,3.37,11.09,0,14.24v-14.24Z",
    className: "patternColor"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M315.77,399.91v-14.04c3.54,1.8,3.87,10.2,0,14.04Z",
    className: "patternColor"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M316.3,350.95c3.08,5.16,2.59,11.38,0,13.42v-13.42Z",
    className: "patternColor"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M508.21,364.71v-14.4c3.1,3.89,2.97,11.46,0,14.4Z",
    className: "patternColor"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M193.16,320.63c3.02,2.86,3.22,10.07,0,14.35v-14.35Z",
    className: "patternColor"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M317.69,197.46v15.12c-2.93-5.4-2.66-12.73,0-15.12Z",
    className: "patternColor"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M407.92,212.47v-14.58c3.27,1.3,3.68,8.75,0,14.58Z",
    className: "patternColor"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M510.66,197.49c-.23,5.08-.42,9.39-.61,13.69-3.56-4.63-2.96-12.19.61-13.69Z",
    className: "patternColor"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M302.04,226.72c-3.32-3.41-3.31-10.19,0-14.43v14.43Z",
    className: "patternColor"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M302,380.63c-3.25-4.19-3.31-10.76,0-14.33v14.33Z",
    className: "patternColor"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M494.21,366.7v13.37c-3.68-2.67-3.83-10.69,0-13.37Z",
    className: "patternColor"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M485.19,320.78c2.97,2.45,3.24,9.02,0,14.42v-14.42Z",
    className: "patternColor"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M293.13,320.58c3.08,2.89,3.24,9.51,0,14.4v-14.4Z",
    className: "patternColor"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M494.23,212.9v13.43c-3.79-2.53-3.68-10.78,0-13.43Z",
    className: "patternColor"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M394.19,211.7v14.36c-3.38-1.67-3.78-8.94,0-14.36Z",
    className: "patternColor"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M216.22,351c3.1,4.23,2.75,10.8,0,13.6v-13.6Z",
    className: "patternColor"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M323.61,249.29v-17.43c.41,0,.83,0,1.24-.02v17.44c-.41,0-.83,0-1.24.02h0Z",
    className: "patternColor"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M346.88,464.4c-3.46-2.74.53-6.31-.19-9.43-.77-3.3-.7-6.8-1-10.22.5-.05,1-.11,1.51-.16l1.21,19.42c-.51.13-1.01.26-1.52.38h-.01Z",
    className: "patternColor"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M384.86,306.47v-12.84c3.73,2.82,3.59,10.12,0,12.84Z",
    className: "patternColor"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M517.1,231.86v17.33h-1.36v-17.34h1.36Z",
    className: "patternColor"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M339.34,152.4v-16.63h1.4v16.63h-1.4Z",
    className: "patternColor"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M592.09,261.25c-.22-4.45-.44-8.9-.66-13.34.64-.07,1.28-.15,1.91-.22l1.47,13.23c-.91.11-1.82.22-2.72.34h0Z",
    className: "patternColor"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M415.88,249.21v-17.35c.32-.02.63-.03.95-.05v17.37c-.32,0-.63.02-.95.02h0Z",
    className: "patternColor"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M225.02,231.84v17.36c-.28,0-.55.02-.83.04v-17.35c.28,0,.55-.03.83-.04h0Z",
    className: "patternColor"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M332.97,149.39c-3.22-2.46-3.4-9.3,0-12.08v12.08Z",
    className: "patternColor"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M554.02,195.49c3.29,2.46,3.57,8.64,0,12.17v-12.17Z",
    className: "patternColor"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M433.15,329.19c-4.37-4.06-1.84-8.34-2.56-12.3,3.34,1.52,3.44,2.01,2.56,12.3Z",
    className: "patternColor"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M394,138.79c-3.29-3.72-3.25-9.91,0-12.41v12.41Z",
    className: "patternColor"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M324.66,141.06v16.09c-.28.03-.56.06-.84.1v-16.1c.28-.03.56-.06.84-.1h0Z",
    className: "patternColor"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M462.91,137.2v15.98l-.86.05v-15.83c.29-.07.58-.14.86-.2Z",
    className: "patternColor"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M333.78,358.95c-.5,3.87-1,7.73-1.5,11.6-.56-.08-1.12-.15-1.68-.23.51-3.87-1.47-8.09,1.5-11.6.56.08,1.12.16,1.67.23h0Z",
    className: "patternColor"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M361.99,187.69v-12.77c.41-.02.82-.04,1.23-.06v12.92l-1.23-.09Z",
    className: "patternColor"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M425.28,308.08v11.55c-3.55-2.16-3.94-7.83,0-11.55Z",
    className: "patternColor"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M563.52,327.78v13.5h-1.39v-13.5h1.39Z",
    className: "patternColor"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M494.13,447.26c.14,3.73,1.62,7.61-1.81,11.86v-12.05c.6.06,1.21.13,1.81.19Z",
    className: "patternColor"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M561.94,368.2v-13.22c.39-.02.78-.05,1.18-.07v13.29h-1.18Z",
    className: "patternColor"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M422.91,239.13c3.62,3.02,3.39,8.68,0,10.31v-10.31Z",
    className: "patternColor"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M523.03,437.87c-.17-3.42-1.87-7.01,1.8-10.87v11.1c-.6-.08-1.2-.15-1.8-.23Z",
    className: "patternColor"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M332.88,427.91v10.77c-3.36-3.92-3.04-8.68,0-10.77Z",
    className: "patternColor"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M232.91,249.73c-3.11-2.58-3.16-7.56,0-10.56v10.56Z",
    className: "patternColor"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M299.49,457.16c.22-3.42.43-6.84.65-10.26.47.03.93.06,1.4.09v10.38c-.68-.07-1.37-.14-2.05-.22h0Z",
    className: "patternColor"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M331.23,284.05v-10.01h1.41v9.96c-.47.01-.94.03-1.41.04h0Z",
    className: "patternColor"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M231.26,403.39l-.81-9.52c.56-.09,1.12-.18,1.67-.27,2.79,2.69.74,6.36,1.23,9.51-.7.1-1.4.19-2.1.29h.01Z",
    className: "patternColor"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M224.99,385.83v14.01c-.26.01-.52.03-.78.04v-14.01c.26-.01.52-.03.78-.04Z",
    className: "patternColor"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M333.18,249.41c-3.62-1.63-3.61-7.12,0-9.76v9.76Z",
    className: "patternColor"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M524.99,403.39c-3.25-2.7-3.39-7.44,0-10.04v10.04Z",
    className: "patternColor"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M424.85,274.26v9.78c-.48,0-.96.02-1.45.03v-9.79c.48,0,.96-.01,1.45-.02Z",
    className: "patternColor"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M241.66,293.95c-.3,3.15-.6,6.3-.91,9.45-.75-.08-1.5-.17-2.24-.25l.57-9.57c.86.12,1.72.25,2.58.37Z",
    className: "patternColor"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M463.29,327.86v13.42c-.41,0-.83,0-1.24-.01v-13.4h1.24Z",
    className: "patternColor"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M271.2,327.86v13.36c-.38,0-.77,0-1.15-.01v-13.36h1.15Z",
    className: "patternColor"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M269.94,368.21v-13.31h1.15v13.35c-.38-.01-.77-.02-1.15-.04Z",
    className: "patternColor"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M430.9,303.46v-9.76c3.58,1.49,3.61,6.96,0,9.76Z",
    className: "patternColor"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M523.32,284.01v-10.13h1.45v10.18c-.48-.02-.96-.03-1.45-.05Z",
    className: "patternColor"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M525.16,239.6v9.75c-3.56-1.46-3.61-6.94,0-9.75Z",
    className: "patternColor"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M530.95,303.8v-10.24c3.36,1.94,3.45,6.74,0,10.24Z",
    className: "patternColor"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M231.37,284.11v-9.93h1.45v9.79l-1.45.14h0Z",
    className: "patternColor"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M430.8,149.96v-10.03c3.55,1.76,3.83,6.19,0,10.03Z",
    className: "patternColor"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M447.57,132.68v9.08c-.44.02-.88.03-1.32.05v-9.02l1.32-.12h0Z",
    className: "patternColor"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M484.89,224.7c3.51,2.48,3.55,7.02,0,9.74v-9.74Z",
    className: "patternColor"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M384.77,234.85v-10.03c3.59,1.98,3.81,6.42,0,10.03Z",
    className: "patternColor"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M271.29,201.13v13.33c-.37-.02-.74-.04-1.12-.06v-13.33c.37.02.74.04,1.12.06Z",
    className: "patternColor"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M539,345.22v-13.35c.27-.02.55-.04.82-.06v13.37l-.82.04Z",
    className: "patternColor"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M247.02,345.22v-13.35l.76-.07v13.39c-.25.01-.51.03-.76.04h0Z",
    className: "patternColor"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M271.26,174.51v13.49c-.3,0-.61.02-.91.03v-13.49l.91-.03Z",
    className: "patternColor"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M462.05,187.85v-13.24c.33-.02.67-.03,1-.05v13.39c-.33-.03-.67-.07-1-.1h0Z",
    className: "patternColor"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M438.97,191.22v-13.34c.28-.03.57-.05.85-.08v13.37c-.28,0-.57.03-.85.04h0Z",
    className: "patternColor"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M463.39,201.02v13.43c-.37,0-.73-.02-1.1-.04v-13.43c.37,0,.73.02,1.1.03h0Z",
    className: "patternColor"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M363.28,201.14v13.25c-.32,0-.64-.03-.96-.04v-13.25c.32,0,.64.03.96.04Z",
    className: "patternColor"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M292.8,234.96v-10.01c3.53,1.72,3.81,6.12,0,10.01Z",
    className: "patternColor"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M485.16,376.82c3.23,5.33,3.07,8.03,0,10.42v-10.42Z",
    className: "patternColor"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M292.85,387.67v-10.02c3.53,3.32,3.6,6.79,0,10.02Z",
    className: "patternColor"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M263.81,427.94v9.24c-3.87-2.68-1.93-6.01-1.78-9.03.59-.07,1.18-.14,1.78-.21Z",
    className: "patternColor"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M471.21,404.98v9.43c-3.63-1.75-3.64-4.4,0-9.43Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternM);
export default __webpack_public_path__ + "static/media/patternM.0c237d992ff20f5e0fe3e6aae53006a7.svg";
export { ForwardRef as ReactComponent };